import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion';
import ScrollToTop from '../components/ScrollToTop';
import Paragraphs from '../components/Paragraphs';
import Spacer from '../components/Spacer';
import CTA from '../components/CTA';
import SocialBlock from '../components/SocialBlock';

import { faqData } from '../static/data';
import Button from '../components/Button';
import SEO from '../components/SEO';

let FAQ = () => {
  let questions = faqData && faqData.faq ? faqData.faq : null;
  return (
    <>
      <SEO
        title="WE3 Academy | FAQ | Coding Bootcamp"
        description="At WE3 Academy, we are bridging the gap between education and employability with our in-person training courses designed to provide you with fundamental skills and real-world experiences to accelerate your career."
        keywords="WE3 Academy, WE3, Coding Bootcamp, Coding academy, coding school, web development bootcamp, education, education center, educational institute, best coding bootcamp, coding bootcamp in India, coding bootcamp in mumbai, best coding bootcamp in mumbai, code school, programming bootcamp, full stack web development course, full stack web development, dev bootcamp, code bootcamp,  career courses, digital courses, course, courses, career development, career development course, social media marketing, social media marketing course, social media, best courses in mumbai, social media courses in mumbai, career development courses in mumbai, part time courses, part time course, full time courses, computer programming, computer coding, training courses, training, in-person training, real world experiences, real work environment, employability, training institute, training bootcamp, training center,"
        link="/faq"
      />
      <div id="faq">
        <ScrollToTop />
        {faqData && faqData.heading && (
          <h1 style={{ margin: '50px 0' }} className="blue uppercase center">
            {faqData.heading}
          </h1>
        )}
        {questions && (
          <Accordion
            className="faq"
            allowMultipleExpanded={true}
            allowZeroExpanded={true}
          >
            {questions.map((faq, faqIdx) => (
              <AccordionItem key={faqIdx}>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <span>{faq.question}</span>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <Paragraphs data={faq.answer} />
                </AccordionItemPanel>
              </AccordionItem>
            ))}
          </Accordion>
        )}
        <Spacer px={35} />
        <div className="center">
          <h3>Got more questions?</h3>
          <p>
            Feel free to email or call us if you have any questions about the
            course or the academy.
          </p>
          <Spacer px={20} />
          <Button type="email" />
          <Button type="call" />
        </div>
        <SocialBlock styleType="style1" />
        <CTA styleType="style1" customCta={faqData.cta} />
      </div>
    </>
  );
};

export default FAQ;
